// extracted by mini-css-extract-plugin
export default {"container":"InterventionBox_container__MH5dY","highlighted":"InterventionBox_highlighted__uqCEn"};